<template>
    <div class="container my-4 flex flex-col items-center justify-evenly gap-x-3 sm:my-12 sm:flex-row">
        <div 
            v-for="(item, index) in statistics" 
            :key="index" 
            class="flex flex-col justify-center items-center text-center"
        >
            <!-- A number, not a heading: the page has its own h1 -->
            <p class="text-3xl font-bold text-[#026DDB] [font-family:var(--font-family-heading)] sm:text-5xl">
                {{ item.number }} <span class="text-[#02AB3B]">+</span>
            </p>
            <p class="text-pretty text-xs text-[#026DDB] sm:text-base">
                {{ item.description }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    statistics: { number: number | string; description: string }[]
}>()
</script>
